import {
	GetStaticProps,
	LiveCasinoPage,
} from "../../bet-nextv1/LiveCasinoPage";

export default LiveCasinoPage;

export const getStaticProps = GetStaticProps;
